import React from 'react';
import dollars from '../../dollar-format';
import {executeQuery} from "../../requests/executeQuery";
import {renderPrintFooter} from "../../utils";
import {HSC_PIPELINE} from "../../consts/queries";
import {columns} from "./columns";
import {HscPipelineModel} from "./hscPipelineModel";
import LinkComp from "../LinkComp/LinkComp";
import hscTeamMembers from '../../hsc-team-members';
import filter from '../../filter';
import Dropdown from '../Dropdown/Dropdown';
// The page is built on the Summit Pipeline's classes; nothing else loads them.
import '../Pipeline/Pipeline.scss';

export default class HscPipeline extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rows: {},
            query:{},
            loading: false,
            isPrint: false,
            printBackground: '',
        };

        this.beforePrint = this.beforePrint.bind(this);
        this.afterPrint = this.afterPrint.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    }

    fetch() {
        this.setState({loading: true});
        let query = {...this.state.query};
        const options = filter(query, 'hscPipeline');
        if(options.filter.where.length==0){
            options.filter.where=['CW1']
        }else  if(options.param.HSC_TEAM_MEMBER_FIRST=="NOMATCH" || options.param.HSC_TEAM_MEMBER_LAST=="NOMATCH" ){
            options.filter.where=['CW1','CW2']
        }else if (typeof options.param.HSC_TEAM_MEMBER_FIRST === 'undefined' && typeof options.param.HSC_TEAM_MEMBER_LAST === 'undefined') {
            options.param.HSC_TEAM_MEMBER_FIRST = 'NOMATCH';
            options.param.HSC_TEAM_MEMBER_LAST = 'NOMATCH';
            options.filter.where = ['CW1'];
        }
        //'gholley@highstcapital.com,jarnold@highstcapital.com'
       // options.param.HSC_TEAM_MEMBER_FIRST = ['gholley@highstcapital.com','jarnold@highstcapital.com'];
        executeQuery({queryName: HSC_PIPELINE, options}).then(res => {
            if (res && res.success && Array.isArray(res.data) && res.data.length) {
                const rows = new HscPipelineModel(res.data[0]);
                this.setState({rows, loading: false});
            }
        });
    }

    componentDidMount() {
        let query={
            HSC_TEAM_MEMBERS:''
        };
        hscTeamMembers.map((el, index)=>{
            query.HSC_TEAM_MEMBERS += el ? index === hscTeamMembers.length-1 ? el.EMAIL:el.EMAIL+',' : '';
        })
        this.setState({query, printBackground: `url('${arc.path.media+'Transaction_Background.png'}')`}, this.fetch);
        window.onbeforeprint = this.beforePrint;
        window.onafterprint = this.afterPrint;
    }
    
    beforePrint() {
        this.setState({isPrint: true});
    }

    afterPrint() {
        this.setState({isPrint: false});
    }

    renderTable(columns, rows) {
        return (
            <table>
                <thead style={{position: 'sticky', top: 0, zIndex: 2}}>
                <tr>
                    {
                        columns.map((column, index) => {
                            return <th key={index} className="Pipeline_th">{column.name}</th>
                        })
                    }
                </tr>
                </thead>
                <tbody>
                {
                    Object.keys(rows).map(key => {
                        return (
                            <tr key={key} className={`${key === 'closedTotal' && 'border-top'}`}>
                                {
                                    columns.map((column, index) => {
                                        let value = '';
                                        if (rows[key][column.key] !== null) {
                                            if (column.format === '$') {
                                                const withCents = column.withCents;
                                                value = dollars(rows[key][column.key], withCents);
                                            } else {
                                                value = rows[key][column.key];
                                            }
                                        }
                                        if (!rows[key].url && index === 0)
                                            return (
                                                <td
                                                    key={key + "-" + index}
                                                    className={`${column.class ? column.class : "Pipeline_td"} ${key === 'closedTotal' && 'Pipeline_th'}`}>
                                                    <LinkComp
                                                        to={`${arc.path.base}list?PEAK_STATUS=${rows[key].status}&SOURCE=PEAK${this.state.query.HSC_TEAM_MEMBERS ? '&PEAK_TEAM_MEMBERS='+this.state.query.HSC_TEAM_MEMBERS.replace(/@highstcapital\.com/gi, '@peakcapital.io') :''}`}>
                                                        {value}
                                                    </LinkComp>
                                                </td>
                                            );
                                        else if (rows[key].url && index === 0)
                                            return (
                                                <td key={key+'-'+index}
                                                className={`${column.class ? column.class : "Pipeline_td"} ${key === 'closedTotal' && 'Pipeline_th'}`}>
                                                    <LinkComp to={`${arc.path.base}pipeline/${rows[key].url}${this.state.query.HSC_TEAM_MEMBERS ? '?PEAK_TEAM_MEMBERS='+this.state.query.HSC_TEAM_MEMBERS.replace(/@highstcapital\.com/gi, '@peakcapital.io') :''}`}>
                                                        {value}
                                                    </LinkComp>
                                                </td>
                                            );
                                        return (
                                            <td key={key+'-'+index}
                                                className={`${column.class ? column.class : 'Pipeline_td'} ${key === 'closedTotal' && 'Pipeline_th'}`}>
                                                {value}
                                            </td>
                                        )
                                    })
                                }
                            </tr>
                        );
                    })
                }
                </tbody>
            </table>
        );
    }
    
    handleChangeDropdown(query, optionType, value, valueKey){
        query.HSC_TEAM_MEMBERS = query[valueKey];   
        this.setState({query}, this.fetch)
    }

    render() {
        const {rows, loading, isPrint, printBackground, query} = this.state;
        const d = new Date();
        const date = d.getMonth()+1+'/'+d.getDate()+'/'+d.getFullYear();

        return (
            <div className='Pipeline'>
                <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                    <div className='Pipeline_head'>
                        <div className="Pipeline_head_left">
                            <h3 className='Pipeline_h3'>Closed</h3>
                            <h4 className='Pipeline_h4'>{date}</h4>
                        </div>
                        <div className='Pipeline_head_right'>
                            <Dropdown
                                dropdownType='multiple'
                                optionsType='team-members'
                                optionLabelKey='NAME'
                                optionKey='EMAIL'
                                value={query.HSC_TEAM_MEMBERS}
                                label='Agent'
                                valueKey='HSC_TEAM_MEMBERS'
                                data={query}
                                handleParentChange={this.handleChangeDropdown}
                            />
                        </div>
                    </div>
                    {
                        loading ?
                            <div className='loading'>Loading data...</div>
                            :
                            this.renderTable(columns, rows)
                    }
                    {renderPrintFooter(isPrint, true)}
                </div>
                <div className='preload-print-background' style={{backgroundImage: printBackground}}/>
            </div>
        );
    }
}
